import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import "../Style.css";
import { Card, InputNumber, message, Modal, Select, Table } from "antd";
import { PartnerPricingdata, pricingData } from "../helper/PricingdashboardData";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PricingForm from "./PricingForm";
import { DeleteOutlined, EditOutlined, EyeOutlined, LeftCircleOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import { partnerDataSuccess } from "../../../redux/PricingPartnerDetails/PricingPartnerDetailsAction";
import { getCategoryList } from "../../../redux/PricingSetupCategory/pricingSetupCategoryAction";
import TextArea from "antd/lib/input/TextArea";
import {
  addPartnerPricingDetails,
  getAllPricingDetailByPartner,
  upadtePartnerPricingDetails,
} from "../../../redux/AddPartnerPricingInfo/action";
import Logout from "../../../containers/Pages/Login/Logout";
import useSession from "../../CustomLogout/useSession";

const PricingCreate = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { partnersdata1, categoryData, existingPricingDetail, accessToken } = props;
  const selectedKey = location.state?.SelectedPartnerCode;
  const editformData = location.state?.formData;

  const [partnerdata, setpartnerdata] = useState([]);
  const [partnerName, setpartnerName] = useState(selectedKey);
  const [pricingdataToSubmit, setpricingdataToSubmit] = useState([]);
  const [submitPayloadTodispay, setSubmitPayloadTodispay] = useState([]);
   const [submitPayloadTodispay2, setSubmitPayloadTodispay2] = useState([]);
  const [categoryData1, setCategoryData] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isRemarkModalVisible, setIsRemarkModalVisible] = useState(false);
  const [selectedPricingDetails, setSelectedPricingDetails] = useState([]);
  const [selectedPricingDetailFixed, setSelectedPricingDetailFixed] =
    useState(null);
  const [selectedPricingType, setSelectedPricingType] = useState(null);
  const [newRemarkcomment, setNewRemarkcomment] = useState(null);
  const [existingPricingData, setExistingPricingData] = useState(existingPricingDetail);
  const handleSessionExpired = useSession();
  const [submitLoading, setSubmitLoading] = useState(false);

  

  useEffect(() => {
  const fetchData = async () => {
    try {
      

      const result = props.partnerData({
        accessToken: accessToken,
      });
      const newPartnerdata = await result;

      // 403 check in response
      const errorCode = newPartnerdata?.response?.data?.error?.errorCode || newPartnerdata?.errorCode;
      if (errorCode === "403" && (newPartnerdata?.data?.error?.logoutStatus || newPartnerdata?.response?.data?.error?.logoutStatus)) {
        handleSessionExpired();
        return;
      }

      const getcategoryData = props.categorySetup({
        accessToken: accessToken,
      });
      const resCategoryData = await getcategoryData;
      setCategoryData(resCategoryData);
      props.GetExistingPricingDetail({ partnerFirmId: selectedKey, accessToken: accessToken });


      const data = newPartnerdata?.map((item, i) => {
        return {
          value: item.partnerFirmId,
          label: item.partnerFirmName + ` (` + item.partnerDisplayCode + `)`,
        };
      });

      setpartnerdata(data);

      const prtnerlableName = newPartnerdata?.filter(
        (item) => item.partnerFirmId == selectedKey
      );

      setpartnerName(
        `${prtnerlableName[0].partnerFirmName}/${prtnerlableName[0].partnerDisplayCode}`
      );
    } catch (e) {
      // 403 check in error
      if (e?.status === 403 || e?.response?.status === 403) {
        handleSessionExpired();
        return;
      }
      console.log(e);
    }
  };

  fetchData();
}, [selectedKey]);

  useEffect(() => {
    setSubmitPayloadTodispay(groupByPricingCode(pricingdataToSubmit));
  }, [pricingdataToSubmit]);

  useEffect(() => {
    const dataofeachdisbusmenttype = [];
      const found1stTrancItem = submitPayloadTodispay.find(item => item?.disbursement == 1);
      const found2stTrancItem = submitPayloadTodispay.find(item => item?.disbursement == 2);
      if (found1stTrancItem) {
        dataofeachdisbusmenttype.push(found1stTrancItem);
      }
      if (found2stTrancItem) {
        dataofeachdisbusmenttype.push(found2stTrancItem);
      }
       setSubmitPayloadTodispay2(dataofeachdisbusmenttype);

  }, [submitPayloadTodispay]);

  useEffect(() => {
    setExistingPricingData(props.existingPricingDetail)

  }, [props.existingPricingDetail]);

  const adminFirstName = (adminName) => {
    if (adminName) return adminName?.toUpperCase()?.charAt(0);
    else return null;
  };

  const adminLastName = (adminLast) => {
    if (adminLast) return adminLast?.toUpperCase()?.charAt(0);
    else return null;
  };

  const groupByPricingCode = (data) => {
    const groupedData = data.reduce((acc, item) => {
      // Check if pricingTypeId is 2
      if (item.priceTypeId === 2) {
        const key = `${item.pricingCode}-${item.effectiveDate}`; // Combine pricingCode and effectiveDate as a unique key
        if (!acc[key]) {
          acc[key] = {
            ...item,
            slabs: [],
          };
        }
        acc[key].slabs.push({
          MinimumSlab: item.startSlab,
          MaximumSlab: item.endSlab,
          Percentage: item.percentage,
          pricingId: item.pricingId ? item.pricingId : 0,
        });
      } else {
        // For other pricingTypeId, keep them as separate records
        const key = `${item.pricingCode}-${item.tracId}`; // Use tracId to ensure uniqueness
        if (!acc[key]) {
          acc[key] = {
            ...item,
            slabs: [
              {
                MinimumSlab: 0,
                MaximumSlab: 0,
                Percentage: item.percentage,
                pricingId: item.pricingId ? item.pricingId : 0,
              },
            ],
          };
        }
      }
      return acc;
    }, {});

    let dataiso = Object.values(groupedData).map((item) => {
      return {
        disbursement: item.trancheId,
        partnerCode: item.partnerId,
        Business: item.businessId,
        Segment: item.segmentId,
        Stream: item.streamId,
        Pricing: item.priceTypeId,
        pricingCode: item.pricingCode,
        country: item.countryId,
        EffDate: item.effectiveDate,
        retrospective: item.retrospective,
        ApprovalStage: item.approvalStageId,
        pricingDetails: item.slabs,
        tracId: item.tracId,
      };
    });

    return dataiso;
  };

  const onChange = (value) => {
    setpricingdataToSubmit([]);
    props.GetExistingPricingDetail({ partnerFirmId: value });
    navigate(`/PayoutMakerDashBoard/AddPartnerPricing`, {
      state: { SelectedPartnerCode: value },
      replace: true,
    }); // Use navigate function
  };

  const handelviewPringdataforPartner = () => {
    navigate(`/PayoutMakerDashBoard/PartnerPricingView`, {
      state: { SelectedPartnerCode: selectedKey },
      replace: true,
    });
  }

  const handleOpenremark = () => {
    setIsRemarkModalVisible(true);
  };


  const checkTrancheIdsForSameEffectiveDate = (data) => {
    const groupedByEffectiveDate = data.reduce((acc, item) => {

      const { effectiveDate, trancheId } = item;
      if (!acc[effectiveDate]) {
        acc[effectiveDate] = new Set();
      }

      acc[effectiveDate].add(trancheId);
      return acc;
    }, {});

    for (const [effectiveDate, trancheIds] of Object.entries(groupedByEffectiveDate)) {
      if (trancheIds.has(1) && trancheIds.has(2)) {
        console.log(`Both trancheId 1 and 2 exist for effectiveDate: ${effectiveDate}`);
        return true;
      }
    }

    return false;
  };


  

  const handleSaveAndSubmitPricing = () => {
  setSubmitLoading(true); // Prevent multiple clicks
  const indivisualdata = [];

  // Check if trancheId 1 and 2 exist for the same effectiveDate
  if (!checkTrancheIdsForSameEffectiveDate(pricingdataToSubmit)) {
    message.error("Both trancheId 1 and 2 must exist for the same effectiveDate.");
    setSubmitLoading(false);
    return;
  }

  if (
    typeof newRemarkcomment !== "string" ||
    newRemarkcomment.trim().length <= 0
  ) {
    setIsRemarkModalVisible(true);
    message.error("Please add some comment");
    setSubmitLoading(false);
    return 0;
  }
  setIsRemarkModalVisible(false);

  // Prepare all API calls
  const apiCalls = pricingdataToSubmit.map((pricingdata) => {
    let data = {};
    if (pricingdata.pricingId) {
      data = {
        trancheId: pricingdata.trancheId,
        businessId: pricingdata.businessId,
        segmentId: pricingdata.segmentId,
        streamId: pricingdata.streamId,
        priceTypeId: pricingdata.priceTypeId,
        countryId: pricingdata.countryId,
        effectiveDate: pricingdata.effectiveDate,
        retrospective: pricingdata.retrospective,
        startSlab: pricingdata.startSlab,
        endSlab: pricingdata.endSlab,
        percentage: pricingdata.percentage,
        partnerId: pricingdata.partnerId,
        pricingId: pricingdata.pricingId, //pass id to update
        pricingCode: null,
        pricingRemarks: [
          {
            pricingRemarkId: 0,
            remarks: newRemarkcomment,
            approvalStageId: (pricingdata.approvalStageId === 2) ? 3 : pricingdata.approvalStageId,
            userRole: props.userDetail?.roleName,
            pricingId: pricingdata.pricingId,
          },
        ],
      };
      return props.UpdatePricingDetail({
        values: data,
        partnerFirmId: data.partnerId,
        accessToken: accessToken,
      });
    } else {
      data = {
        trancheId: pricingdata.trancheId,
        businessId: pricingdata.businessId,
        segmentId: pricingdata.segmentId,
        streamId: pricingdata.streamId,
        priceTypeId: pricingdata.priceTypeId,
        countryId: pricingdata.countryId,
        effectiveDate: pricingdata.effectiveDate,
        retrospective: pricingdata.retrospective,
        startSlab: pricingdata.startSlab,
        endSlab: pricingdata.endSlab,
        percentage: pricingdata.percentage,
        partnerId: pricingdata.partnerId,
        approvalStageId: pricingdata.approvalStageId,
        pricingRemarks: [
          {
            pricingRemarkId: 0,
            remarks: newRemarkcomment,
            approvalStageId: pricingdata.approvalStageId,
            userRole: props.userDetail?.roleName,
          },
        ],
      };
      return props.AddPricingDetail({
        values: data,
        partnerFirmId: data.partnerId,
        accessToken: accessToken,
      });
    }
  });

  Promise.all(apiCalls)
    .then((results) => {
      setpricingdataToSubmit([]);
      message.success(` Successfully submitted to CET Checker`);
     setTimeout(() => {
        setSubmitLoading(false);
        navigate(`/PayoutMakerDashBoard/PartnerPricingView`, {
          state: { SelectedPartnerCode: selectedKey },
          replace: true,
        });
      }, 2000);
    })
    .catch((err) => {
      console.log(err);
      message.error("Error while submitting data");
      setSubmitLoading(false);
    });
};

  const handleDelete = (partnerCode) => {
    const updatedData = pricingdataToSubmit.filter(
      (item) => item.trancheId !== partnerCode.disbursement
    );
    setpricingdataToSubmit(updatedData);
    
    message.success("Item deleted successfully");
    
  };

  const handleViewPricingDetails = (record, pricingType) => {
    
    setSelectedPricingType(pricingType);
    if (pricingType === "Slab") {
      setSelectedPricingDetails(record);
    } else {
      setSelectedPricingDetailFixed(record?.[record.length - 1]);
    }

    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    setIsRemarkModalVisible(false);
    setSelectedPricingDetailFixed(null); // Clear the fixed value when modal closes
    setSelectedPricingDetails([]);  // Clear slab details as well
  };

  const pricingDetailsColumns = [];

  const columns = [
    {
      title: "Disbursement Type",
      dataIndex: "disbursement",
      key: "disbursement",
      align: "center",
    },
    // {
    //   title: "Partner Code",
    //   dataIndex: "partnerCode",
    //   key: "partnerCode",
    //   align: "right",
    // },
    // {
    //   title: "Business",
    //   dataIndex: "Business",
    //   key: "Business",
    //   align: "left"
    // },

    // {
    //   title: "Segment",
    //   dataIndex: "Segment",
    //   key: "Segment",
    //   align: "left",
    // },

    // {
    //   title: "Stream",
    //   dataIndex: "Stream",
    //   key: "Stream",
    //   align: "left",
    // },

    // {
    //   title: "Country",
    //   dataIndex: "country",
    //   key: "country",
    //   align: "left",
    // },

    {
      title: "Pricing Type",
      dataIndex: "Pricing",
      key: "Pricing",
      align: "center",
    },

    {
      title: "Pricing Percentage",
      dataIndex: "PricingID",
      key: "PricingID",
      align: "center",
    },
    {
      title: "Retrospective",
      dataIndex: "retrospective",
      key: "retrospective",
      align: "center",
    },
    {
      title: "Effective Date",
      dataIndex: "EffDate",
      key: "EffDate",
      align: "center",
    },

    {
      title: "Status",
      dataIndex: "ApprovalStage",
      key: "ApprovalStage",
      align: "center",
    },

    {
      title: "Action",
      dataIndex: "operations",
      key: "operations",
      align: "center",

    },
  ];

  const mapCategoryValues = (item, categoryData) => {
    const getCategoryName = (categoryType, id) => {
      const category = categoryData[categoryType]?.find(
        (cat) => cat.catId === id
      );

      return category ? category.catName : null;
    };
    

    return {
      ...item,
      disbursement: getCategoryName("tranche", item.disbursement),
      Business: getCategoryName("business", item.Business),
      Segment: getCategoryName("segment", item.Segment),
      Stream: getCategoryName("stream", item.Stream),
      Pricing: getCategoryName("priceType", item.Pricing),
      PricingID: (
        <Button
          type="link"
          onClick={() =>
            handleViewPricingDetails(
              item.pricingDetails,
              getCategoryName("priceType", item.Pricing)
            )
          }
          style={{ background: "#1b8593" }}
        >
          <EyeOutlined />
        </Button>
      ),
      country: getCategoryName("country", item.country),
      ApprovalStage: getCategoryName("approvalStage", item.ApprovalStage),
      operations:
        (
          <>
            <div

              onClick={() => handleDelete(item)}
              style={{
                color: "#000",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <DeleteOutlined />
            </div>
          </>
        ),
    };
  };

  return (
    <div className="" style={{ maxWidth: "100%" }}>
      <Row>
        <Col lg={12} xs={12} md={12} sm={12} className="partnerHeadre">
          <Col md={8} className="search-bar">
           <Button
                        type="default"
                        className="back-buttonone" 
                        style={{
                          margin: "0",
                          border: 'none',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '2px', // space between icon and text
                          padding: '0 8px',
                          color: '#00b1b1',
                          backgroundColor: 'transparent',
                        }}
                        onClick={() => navigate(-1)}
                      >
                        <LeftCircleOutlined />
                        <span>Back</span>
                      </Button>
          </Col>

          <Col md={4}>
            <div className="login-profie">
              <div className="img-sec">
                <h2>
                  {adminFirstName(
                    props.userDetail?.firstName ??
                    props.userDetail?.userName?.split(" ")[0]?.trim()
                  )}

                </h2>
                <h2>
                  {adminLastName(
                    props.userDetail?.lastName ??
                    props.userDetail?.userName?.split(" ")[1]?.trim()
                  )}
                </h2>
              </div>

              <div className="content-login">
                <h4>{props.userDetail?.userName}</h4>
                <h5>{props.userDetail?.roleName}</h5>

                <div className="content-login-data">
                  {/* <ChangePassword /> */}
                  <div className="admin-small-space"> </div>

                  <Logout />
                  {/* <h6>Change Password | Logout</h6> */}
                </div>
              </div>
            </div>
          </Col>
        </Col>
      </Row>

      <Row>
        <Col lg={12} xs={12} md={12} sm={12}>
          <Col md={6} style={{ display: "flex" }} className="btn-partner">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h5
                style={{ fontWeight: 700, fontSize: "0.9rem", margin: "20px" }}
              >
                Partner :{" "}
                <span style={{ color: "#35cd7a" }}>{partnerName}</span>
              </h5>
              {editformData ? "[Resolve Partner Pricing]"
                : <Select
                  showSearch
                  placeholder="Change Partner"
                  optionFilterProp="label"
                  onChange={onChange}
                  // onSearch={onSearch}
                  style={{ width: 200 }}
                  options={partnerdata}
                />}
            </div>
          </Col>
        </Col>
      </Row>
      <Row>
        <Col lg={12} xs={12} md={12} sm={12}>
          <Row>
            <PricingForm
              partnerCode={selectedKey}
              pricingdataToSubmit={pricingdataToSubmit}
              existingPricingDetail={existingPricingData}
              setpricingdataToSubmit={setpricingdataToSubmit}
              editformData={editformData}
            />
          </Row>
        </Col>

        <Col lg={12} xs={12} md={12} sm={12}>
          <Card style={{ marginTop: 10 }}>
            <Button style={{ float: "right", margin: "3px", background: "#1b8593" }} onClick={handelviewPringdataforPartner}>View Pricing </Button>
            <Table
              dataSource={submitPayloadTodispay2.map((item) =>
                mapCategoryValues(item, categoryData1)
              )}
              columns={columns}
              pagination={{pageSize:15}}
            />
            <Modal
              title="Pricing Details"
              visible={isModalVisible}
              onCancel={handleCloseModal}
              footer={null}
            >
              {selectedPricingType === "Slab" && (
                <>
                  <div></div>
                  <Table
                    dataSource={selectedPricingDetails}
                    columns={[
                      {
                        title: "Minimum slab",
                        dataIndex: "MinimumSlab",
                        key: "MinimumSlab",
                      },
                      {
                        title: "Maximum slab",
                        dataIndex: "MaximumSlab",
                        key: "MaximumSlab",
                      },
                      {
                        title: "Percentage",
                        dataIndex: "Percentage",
                        key: "Percentage",
                      },
                    ]}
                    pagination={{pageSize:5}}
                  />
                </>
              )}

              {selectedPricingType === "Fixed" && (
                <>
                  <div>
                    Fixed Percentage :
                    {/* <InputNumber
                      style={{ color: "#000", fontWeight: 300 }}
                      defaultValue={selectedPricingDetailFixed?.Percentage}
                      size="large"
                      min={0}
                      max={100}
                      disabled={true}
                      formatter={(value) => `${value}%`}
                      parser={(value) => value?.replace("%", "")}
                    /> */}
                    {selectedPricingDetailFixed?.Percentage + "%"}
                  </div>
                  <div></div>
                </>
              )}
            </Modal>

            <Modal
              title="Pricing Remark"
              visible={isRemarkModalVisible}
              onCancel={handleCloseModal}
              footer={null}
            >
              <TextArea
                placeholder="Please add comment to submit"
                onChange={(e) => setNewRemarkcomment(e.target.value)}
                autoSize={{ minRows: 2, maxRows: 6 }}
              />
              <Button
                disabled={submitLoading || newRemarkcomment === null || newRemarkcomment.trim().length === 0}
                type="link"
                onClick={() => handleSaveAndSubmitPricing()}
                style={{ background: "#1b8593", marginTop: "0.3rem" }}
              >
                {submitLoading ? "Submitting..." : "Submit"}
              </Button>
            </Modal>
            <Button
              disabled={pricingdataToSubmit.length === 0}
              type="link"
              onClick={() => handleOpenremark()}
              style={{
                background: "#1b8593",
                float: "right",
                marginTop: "0.4rem",
              }}
            >
              Save and Submit
            </Button>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    partnerData: (data) => dispatch(partnerDataSuccess(data)),
    categorySetup: (data) => dispatch(getCategoryList(data)),
    AddPricingDetail: (data) => dispatch(addPartnerPricingDetails(data)),
    UpdatePricingDetail: (data) => dispatch(upadtePartnerPricingDetails(data)),
    GetExistingPricingDetail: (data) =>
      dispatch(getAllPricingDetailByPartner(data)),
  };
};

const mapStateToProps = (state) => {

  return {
    partnersdata1: state.pricigPartner.partnerDetail,
    categoryData: state.pricingFormSetup.formSetuCtegory,
    existingPricingDetail: state.AddPricingDetail.getPricingPartnerDetail,
    accessToken: state && state.auth && state.auth.idToken,
    loading: state.pricigPartner.loading,
    error: state.pricigPartner.error,
    userDetail: state.auth?.userData,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PricingCreate);
